import { motion } from "framer-motion";
import RuleArt from "@/components/art/RuleArt";
import { useCourtyard } from "@/context/CourtyardContext";
import { SectionHead } from "@/components/invite/Reveal";
import AcceptFarmaan from "@/components/invite/AcceptFarmaan";

const THEMES = [
  { bg: "bg-pink-print", text: "text-[var(--cream)]", num: "text-[var(--yellow)]", sub: "text-[var(--cream)]" },
  { bg: "bg-yellow-print", text: "text-[var(--navy)]", num: "text-[var(--pink-deep)]", sub: "text-[var(--navy)]" },
  { bg: "bg-[var(--cream)]", text: "text-[var(--navy)]", num: "text-[var(--pink)]", sub: "text-[var(--navy)]" },
];
const TILT = [-1.2, 0.8, -0.6, 1, -0.8];

export default function Rules() {
  const { event: ev } = useCourtyard();
  const rules = Array.isArray(ev.rules) ? ev.rules : [];
  if (!rules.length) return null;
  const n = rules.length;
  return (
    <section id="rules" className="paper relative scroll-mt-16 py-20 lg:py-28" aria-labelledby="rules-title">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <SectionHead eyebrow="House rules" title={ev.rules_title} id="rules-title">{ev.rules_subtitle}</SectionHead>
        <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-6">
          {rules.map((r, i) => {
            const t = THEMES[i % 3];
            const span = n === 4 ? "lg:col-span-3" : n === 5 ? (i < 3 ? "lg:col-span-2" : "lg:col-span-3") : "lg:col-span-2";
            const lastOdd = i === n - 1 && n % 2 === 1 ? "sm:col-span-2 lg:col-span-3" : "";
            return (
              <motion.li
                key={r.id || i}
                className={`${span} ${lastOdd}`}
                initial={{ opacity: 0, y: 30, rotate: 0 }}
                whileInView={{ opacity: 1, y: 0, rotate: TILT[i % 5] }}
                whileHover={{ rotate: 0, y: -4 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              >
                <article className={`pop relative flex h-full flex-col overflow-hidden p-6 sm:p-7 ${t.bg} ${t.text}`} data-testid={`rule-card-${i + 1}`}>
                  <div className="flex items-start justify-between gap-4">
                    <span className={`font-poster text-[5.5rem] leading-[0.8] ${t.num}`} aria-hidden="true">{String(i + 1).padStart(2, "0")}</span>
                    <span className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full border-[2.5px] border-[var(--navy)] bg-[var(--cream)]"><RuleArt icon={r.icon} className="h-14 w-14" /></span>
                  </div>
                  <h3 className="font-poster mt-5 text-[1.9rem] leading-[0.98]"><span className="sr-only">Rule {i + 1}: </span>{r.title}</h3>
                  <p className={`mt-3 text-base leading-relaxed sm:text-[1.05rem] ${t.sub}`}>{r.text}</p>
                </article>
              </motion.li>
            );
          })}
        </ol>
        <AcceptFarmaan />
      </div>
    </section>
  );
}
